// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import BulkAssignmentController from "./bulk_assignment_controller"
application.register("bulk-assignment", BulkAssignmentController)

import CachedFormController from "./cached_form_controller"
application.register("cached-form", CachedFormController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ChatToggleController from "./chat_toggle_controller"
application.register("chat-toggle", ChatToggleController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CompetencyWeightsController from "./competency_weights_controller"
application.register("competency-weights", CompetencyWeightsController)

import CustomTooltipController from "./custom_tooltip_controller"
application.register("custom-tooltip", CustomTooltipController)

import DefinitionableSelectController from "./definitionable_select_controller"
application.register("definitionable-select", DefinitionableSelectController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FavoriteController from "./favorite_controller"
application.register("favorite", FavoriteController)

import FilePreviewController from "./file_preview_controller"
application.register("file-preview", FilePreviewController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FilterbarController from "./filterbar_controller"
application.register("filterbar", FilterbarController)

import FormController from "./form_controller"
application.register("form", FormController)

import FormPreviewRefresherController from "./form_preview_refresher_controller"
application.register("form-preview-refresher", FormPreviewRefresherController)

import FormSelectController from "./form_select_controller"
application.register("form-select", FormSelectController)

import HideByController from "./hide_by_controller"
application.register("hide-by", HideByController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import InlineTabsController from "./inline_tabs_controller"
application.register("inline-tabs", InlineTabsController)

import JobProfileFillerController from "./job_profile_filler_controller"
application.register("job-profile-filler", JobProfileFillerController)

import LeftMenuController from "./left_menu_controller"
application.register("left-menu", LeftMenuController)

import LeniencyEntryController from "./leniency_entry_controller"
application.register("leniency-entry", LeniencyEntryController)

import LinkController from "./link_controller"
application.register("link", LinkController)

import MailTemplateController from "./mail_template_controller"
application.register("mail-template", MailTemplateController)

import MediaController from "./media_controller"
application.register("media", MediaController)

import NewsArticlesController from "./news_articles_controller"
application.register("news-articles", NewsArticlesController)

import OnlineActivityChartController from "./online_activity_chart_controller"
application.register("online-activity-chart", OnlineActivityChartController)

import OnlineCountPillController from "./online_count_pill_controller"
application.register("online-count-pill", OnlineCountPillController)

import OtpController from "./otp_controller"
application.register("otp", OtpController)

import OverviewListController from "./overview_list_controller"
application.register("overview-list", OverviewListController)

import PasswordController from "./password_controller"
application.register("password", PasswordController)

import PaymentMethodController from "./payment_method_controller"
application.register("payment-method", PaymentMethodController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import RemovalsController from "./removals_controller"
application.register("removals", RemovalsController)

import ReportOptionPrefillController from "./report_option_prefill_controller"
application.register("report-option-prefill", ReportOptionPrefillController)

import ResizableController from "./resizable_controller"
application.register("resizable", ResizableController)

import ScoreSelectController from "./score_select_controller"
application.register("score-select", ScoreSelectController)

import ScrollEndController from "./scroll_end_controller"
application.register("scroll-end", ScrollEndController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SearchbarController from "./searchbar_controller"
application.register("searchbar", SearchbarController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SelectFilterController from "./select_filter_controller"
application.register("select-filter", SelectFilterController)

import SelectedRowController from "./selected_row_controller"
application.register("selected-row", SelectedRowController)

import SessionMonitorController from "./session_monitor_controller"
application.register("session-monitor", SessionMonitorController)

import ShowByController from "./show_by_controller"
application.register("show-by", ShowByController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SsoController from "./sso_controller"
application.register("sso", SsoController)

import StickyTableHeaderController from "./sticky_table_header_controller"
application.register("sticky-table-header", StickyTableHeaderController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleByController from "./toggle_by_controller"
application.register("toggle-by", ToggleByController)

import ToggleVisibilityController from "./toggle_visibility_controller"
application.register("toggle-visibility", ToggleVisibilityController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TopmenuDropdownController from "./topmenu_dropdown_controller"
application.register("topmenu-dropdown", TopmenuDropdownController)

import TurboFrameMissingHandlerController from "./turbo_frame_missing_handler_controller"
application.register("turbo-frame-missing-handler", TurboFrameMissingHandlerController)

import UnstyledDialogController from "./unstyled_dialog_controller"
application.register("unstyled-dialog", UnstyledDialogController)

import UploadController from "./upload_controller"
application.register("upload", UploadController)

import VariableInserterController from "./variable_inserter_controller"
application.register("variable-inserter", VariableInserterController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)
